var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13.875C10.797 13.875 13.875 10.797 13.875 7C13.875 3.20304 10.797 0.125 7 0.125C3.20304 0.125 0.125 3.20304 0.125 7C0.125 10.797 3.20304 13.875 7 13.875ZM10.9433 5.36254C11.1098 5.15226 11.0959 4.84592 10.9017 4.65165L10.8549 4.61002C10.6446 4.44351 10.3383 4.45738 10.144 4.65165L5.97741 8.81827L4.08312 6.92449L4.03639 6.88287C3.82612 6.71635 3.51977 6.73023 3.32551 6.92449C3.1163 7.1337 3.1163 7.4729 3.32551 7.68211L5.59835 9.95495L5.64507 9.99658C5.85535 10.1631 6.1617 10.1492 6.35596 9.95495L10.9017 5.40927L10.9433 5.36254Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Tick.2368f86c560dd49dc29ec8c66263e507.svg";